import * as React from 'react';

import Markdown from 'bundles/cms/components/Markdown';

import 'css!bundles/xddp/components/__styles__/landing/ProgramOverview';

type Props = {
  marketingContent?: string | null;
};

const ProgramOverview = ({ marketingContent }: Props) => {
  if (!marketingContent) {
    return null;
  }

  return (
    <div className="rc-ProgramOverview rc-Section" dir="ltr">
      <Markdown className="programHighlights" source={marketingContent} />
    </div>
  );
};

export default ProgramOverview;
